import { render, staticRenderFns } from "./PhoneField.vue?vue&type=template&id=a5468858&scoped=true&"
import script from "./PhoneField.vue?vue&type=script&lang=ts&"
export * from "./PhoneField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5468858",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5468858')) {
      api.createRecord('a5468858', component.options)
    } else {
      api.reload('a5468858', component.options)
    }
    module.hot.accept("./PhoneField.vue?vue&type=template&id=a5468858&scoped=true&", function () {
      api.rerender('a5468858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shared/shared/components/PhoneField.vue"
export default component.exports